const BASE_URL = process.env.REACT_APP_BASE_URL

export default function fetchWithBaseUrl(path, options?) {
  return window.fetch(BASE_URL + path.replace(/^\//, ''), options)
}
